/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * When set, this task was recreated with a new id because its type changed.
 */
export type TaskRemintedFromTaskId = string | null;
